import { Link } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import { SEO } from '../components/SEO';
import { PageHero } from '../components/PageHero';
import { ScrollReveal } from '../components/ScrollReveal';
import { DarkTexture } from '../components/DarkTexture';
import { newsItems } from '../data/newsItems';

const News = () => (
  <div className="bg-navy">
    <SEO
      title="DPDPA News — Latest Updates on India's Data Protection Act"
      description="Track the DPDPA and DPDP Rules 2025 milestones — Data Protection Board updates, Consent Manager registration, and the countdown to the 13 May 2027 compliance deadline."
      path="/news"
    />
    <PageHero
      testId="news-page-hero"
      kicker="DPDPA News"
      title="Milestones &amp; updates"
      description="Tracking the DPDPA and DPDP Rules, 2025 as they move from notification to full enforcement on 13 May 2027."
    />

    <section className="bg-surface py-12 px-6 sm:px-10 lg:px-16 border-y border-white/10" data-testid="news-newsletter-section">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-cyan flex items-center justify-center shrink-0">
            <Mail className="text-navy" size={18} />
          </div>
          <div>
            <p className="text-white font-serif text-lg leading-tight">Want to be notified of new updates?</p>
            <p className="text-white/50 text-xs">Get in touch and our team will keep you posted on DPDPA milestones.</p>
          </div>
        </div>
        <Link
          to="/compliance-assessment"
          data-testid="news-contact-cta-button"
          className="inline-flex items-center gap-2 bg-cyan text-navy px-5 py-3 text-sm font-semibold rounded-lg hover:shadow-[0_0_20px_rgba(0,240,255,0.4)] transition-all shrink-0 w-fit"
        >
          Get in Touch <ArrowRight size={14} />
        </Link>
      </div>
    </section>

    <section className="relative bg-navy py-16 sm:py-24 px-6 sm:px-10 lg:px-16 overflow-hidden" data-testid="news-list-section">
      <DarkTexture orbs={false} />
      <div className="relative max-w-3xl mx-auto">
        {newsItems.map((n, i) => (
          <ScrollReveal key={n.id} delay={i * 0.04}>
            <div data-testid={`news-item-${n.id}`} className="flex flex-col sm:flex-row gap-4 sm:gap-10 py-7 border-b border-white/10">
              <p className="font-mono text-sm text-cyan w-32 shrink-0">{n.date}</p>
              <div>
                <p className="font-mono text-[11px] uppercase tracking-widest text-white/30 mb-2">{n.tag}</p>
                <h2 className="font-serif text-xl text-white mb-2">{n.title}</h2>
                <p className="text-sm text-white/50 leading-relaxed">{n.summary}</p>
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </section>
  </div>
);

export default News;
